<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="FileIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="exportRecord()"
    />
    <!--<feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />-->
    
  </div>
</template>

<script>
import moment from "moment-timezone";
import ls from "@/common/localStorage";
export default {
  name: "CellRendererExport",
  watch: {
  },
  methods: {
    exportRecord() {
      this.$vs.loading();
      let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
      this.$store
        .dispatch("chatgroupManagement/getRoomStats", {
          roomId: this.params.data.roomId,
          maxRank: 5
        })
        .then((row) => {
          this.$vs.loading.close();
          if (row) {
            var datarow = [];            
            var AttendeeData = [];
              
              datarow.push("Chat Room Name");
              datarow.push('"' + row.roomName + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Data Exported in");
              datarow.push('"' + moment().tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + ` (${Session_Event_TZ})` + '"');             
              AttendeeData.push(datarow); datarow = [];  
              datarow.push("Top 5 Participants");
              let contributorsNames = row.topContributors.map(item=>{ return item.userName }) 
              datarow.push('"' + contributorsNames.join('/ ') + '"');
              AttendeeData.push(datarow); datarow = []; 
              datarow.push("Total Message Posted"); 
              datarow.push('"' + row.totMessagePostCount + '"');
              AttendeeData.push(datarow); datarow = []; 
              datarow.push("First Activity");
              datarow.push('"' + moment(row.firstActivityDtmUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("No of Reactions");
              datarow.push('"' + row.totReactionCount + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Last Activity");
              datarow.push('"' + moment(row.lastActivityDtmUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
              AttendeeData.push(datarow); datarow = [];
              datarow.push("Images/Files Shared");
              datarow.push('"' + `${row.totImageShareCount} / ${row.totFileShareCount}` + '"');
              AttendeeData.push(datarow); datarow = [];
              AttendeeData.push([]);

              datarow.push("Message Date&Time");
              datarow.push("Sender Name");
              datarow.push("Message");
              AttendeeData.push(datarow);
              if(row.messages.length){
                row.messages.filter(u=>{ 
                  datarow = [];                 
                  datarow.push('"' + moment(u.sentAtUTC).tz(Session_Event_TZ).format('MMM DD, YYYY HH:mm A') + '"');
                  datarow.push('"' + u.senderName + '"');
                  datarow.push('"' + u.messageText.replace(/[^a-zA-Z0-9-. ]/g, "") + '"');
                  AttendeeData.push(datarow);
                })
              }           
            //});

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = row.roomName+"_chatStatsExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        })
        .catch(err => {
          this.$vs.loading.close();
        });
    },
  }
};
</script>
